import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css'; // 引入CSS文件

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1 className="not-found-header">404</h1>
      <p className="not-found-message">很抱歉，頁面不存在。</p>
      <Link to="/" className="not-found-button">回首頁</Link>
    </div>
  );
};

export default NotFound;
